import { buildingSlice } from './building/buildingSlice';
import { configSlice } from './config/configSlice';
import { dateSlice } from './date/dateSlice.ts';
import { kantoordagApi } from './kantoordagApi';
import { kantoordagDayViewStreamingApi } from './kantoordag/kantoordagDayViewStreamingApi.ts';
import { kantoordagBuildingViewStreamingApi } from './kantoordag/kantoordagBuildingViewStreamingApi.ts';
import { kantoordagParkingViewStreamingApi } from './kantoordag/kantoordagParkingViewStreamingApi.ts';
import { kantoordagMyReservationsStreamingApi } from './kantoordag/kantoordagMyReservationsStreamingApi.ts';
import { buildingsStreamingApi } from './kantoordag/buildingsStreamingApi.ts';
import { migrationStreamApi } from './migration/migrationStreamApi.ts';
import type { Action, ThunkAction } from '@reduxjs/toolkit'
import { combineSlices, configureStore } from '@reduxjs/toolkit'
import { userSlice } from './user/userSlice';
import { setStoreInstance } from './storeInstance';

const rootReducer = combineSlices(
    configSlice,
    userSlice,
    buildingSlice,
    dateSlice,
    kantoordagApi,
    kantoordagDayViewStreamingApi,
    kantoordagBuildingViewStreamingApi,
    kantoordagParkingViewStreamingApi,
    kantoordagMyReservationsStreamingApi,
    buildingsStreamingApi,
    migrationStreamApi,
);

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
        reducer: rootReducer,
        devTools: process.env.NODE_ENV !== "production",
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware().concat(
                kantoordagApi.middleware,
                kantoordagDayViewStreamingApi.middleware,
                kantoordagBuildingViewStreamingApi.middleware,
                kantoordagParkingViewStreamingApi.middleware,
                kantoordagMyReservationsStreamingApi.middleware,
                buildingsStreamingApi.middleware,
                migrationStreamApi.middleware,
            );
        },
    })

setStoreInstance(store);

export type AppStore = typeof store;
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"];
export type AppThunk<ThunkReturnType = void> = ThunkAction<
    ThunkReturnType,
    RootState,
    unknown,
    Action
>;